import { render, staticRenderFns } from "./VyungCPQ.vue?vue&type=template&id=33eb7217&"
import script from "./VyungCPQ.vue?vue&type=script&lang=js&"
export * from "./VyungCPQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports